var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechnicityElectricity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2951 7.99784C5.2951 6.74076 5.2951 6.11223 5.68563 5.7217C6.07615 5.33118 6.70469 5.33118 7.96177 5.33118H9.2951C10.5522 5.33118 11.1807 5.33118 11.5712 5.7217C11.9618 6.11223 11.9618 6.74076 11.9618 7.99784V9.33118C11.9618 10.5883 11.9618 11.2168 11.5712 11.6073C11.1807 11.9978 10.5522 11.9978 9.2951 11.9978H7.96177C6.70469 11.9978 6.07615 11.9978 5.68563 11.6073C5.2951 11.2168 5.2951 10.5883 5.2951 9.33118V7.99784Z",
    stroke: "#222222"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.2951,
    y: 7.33118,
    width: 2.66667,
    height: 2.66667,
    rx: 1,
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2951 5.33118V3.33118",
    stroke: "#222222",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96179 5.33118V3.33118",
    stroke: "#222222",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9617 7.33118L13.9617 7.33118",
    stroke: "#222222",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9617 9.9978L13.9617 9.9978",
    stroke: "#222222",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2951 13.9979V11.9979",
    stroke: "#222222",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96179 13.9979V11.9979",
    stroke: "#222222",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.29511 7.33118L5.2951 7.33118",
    stroke: "#222222",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2951 9.9978L5.2951 9.9978",
    stroke: "#222222",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnicityElectricity);
export default __webpack_public_path__ + "static/media/technicity-electricity.ece4b8a087fd5410abdb573607bc9a29.svg";
export { ForwardRef as ReactComponent };